import React from "react";
import "../css/Header.css";
import { Link } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';
import {FadeTransform} from 'react-animation-components';

import {Nav,Navbar,NavLink} from 'react-bootstrap';

function Header() {
  return (
    <div>
      {/* <div style={{marginBottom:"0px"}} className="jumbotron jumbotron-fluid">
            <h1 className="heading">Portfolio Website</h1>
        </div> */}

      <FadeTransform
          in
          transformProps={{
              enterTransform: 'translateY(0px)',
              exitTransform: 'translateY(-100px)'
          }}
      >
      {/* <nav class="navbar navbar-expand-lg navbar-light navbar-custom">
        <ul class="navbar-nav">
          <li class="nav-item">        
            <Link to="/home">
              <div className="icon">
                <span style={{ padding: "5px",color:"#121846" }} className="fa fa-user fa-lg"></span>{" "}
                Me
              </div>
            </Link>
          </li>
        </ul>
        {/* <a class="navbar-brand" href="/home">
                <span style={{padding:"5px"}} className="fa fa-user fa-lg"></span> Me
                </a> */}
        {/* <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="#navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div 
        class="collapse navbar-collapse pages" 
        id="navbarSupportedContent">
          <ul class="navbar-nav"> */}
            {/* <li class="nav-item">
              <Link to="/about">About</Link>
              {/* <a class="nav-link" href="/about">About <span class="sr-only">(current)</span></a> */}
            {/* </li> */} 
            {/* <li class="nav-item">
              <Link to="/skill">Skills</Link> */}
              {/* <a class="nav-link" href="/skill">Skills <span class="sr-only">(current)</span></a> */}
            {/* </li>
            <li class="nav-item">
              <Link to="/education">Education</Link> */}
              {/* <a class="nav-link" href="/education">Education</a> */}
            {/* </li>
            <li class="nav-item">
              <Link to="/project">Projects</Link> */}
              {/* <a class="nav-link" href="/project">Projects</a> */}
            {/* </li> */}
            {/* <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Something else here</a>
                    </div>
                </li> */}
          {/* </ul>
        </div>
      </nav> */} 
      
      <Navbar collapseOnSelect expand="md" className="color-nav" variant="dark">
        <div class="nav-item">
          <Link to="/home">
            <div className="icon">
              <span style={{ padding: "5px",color:"#121846" }} className="fa fa-user fa-lg"></span>{" "}
              Me
            </div>
          </Link>
        </div>
        <Navbar.Toggle aria-controls="navbarScroll" data-bs-target="#navbarScroll"/>
        <Navbar.Collapse if="navbarScroll">
          <Nav className="pages">
          <NavLink class="nav-item" eventKey="1" as={Link} to="/skill">Skills</NavLink>
          <NavLink class="nav-item" eventKey="2" as={Link} to="/education">Education</NavLink>
          <NavLink class="nav-item" eventKey="3" as={Link} to="/project">Projects</NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      
      </FadeTransform>
    </div>
  );
}

export default Header;
